// extracted by mini-css-extract-plugin
export default {"sectionTitle":"ywce41","toolTitle":"JkcIhV","toolDescription":"iLWyeO","mobileIllustration":"dFuovm"};